import React from 'react';
import {DimensionValue, Modal, Pressable, StyleSheet, View} from 'react-native';

// Both halves of the sheet carry a testID: `Pressable` is a memo-wrapped
// component, which react-test-renderer cannot match by type, so a test has no
// other stable handle on the backdrop.
export const SLIDE_UP_MODAL_BACKDROP_TEST_ID = 'slide-up-modal-backdrop';
export const SLIDE_UP_MODAL_SHEET_TEST_ID = 'slide-up-modal-sheet';

function SlideUpModal({
  isVisible,
  children,
  heightPercent = '25%',
  onRequestClose,
}: {
  isVisible: boolean;
  children?: React.ReactNode;
  heightPercent?: DimensionValue;
  onRequestClose?: () => void;
}) {
  return (
    <Modal
      visible={isVisible}
      transparent={true}
      animationType="slide"
      onRequestClose={onRequestClose}>
      {/* Transparent backdrop: it fills the space the sheet leaves free and is
          kept out of the accessibility tree, since the sheet carries its own
          close control. */}
      <Pressable
        testID={SLIDE_UP_MODAL_BACKDROP_TEST_ID}
        style={styles.backdrop}
        accessible={false}
        importantForAccessibility="no"
        onPress={() => onRequestClose?.()}
      />
      <View
        testID={SLIDE_UP_MODAL_SHEET_TEST_ID}
        style={[styles.modalContainer, {height: heightPercent}]}>
        {children}
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
  },
  modalContainer: {
    marginTop: 'auto',
    backgroundColor: '#cdc8d5',
  },
});

export default SlideUpModal;
